<template>
    <v-dialog scrollable :fullscreen="isMobile" v-model="dialog" max-width="500px" :transition="isMobile ? 'dialog-bottom-transition' : 'dialog-transition'" @click:outside="hide">
        <v-card tile flat dark :class="isMobile ? 'no-radius' : 'card-container'">
            <v-app-bar dark flat>
                <v-row align="center" no-gutters>
                    <v-col cols="2">
                        <v-btn color="primary" icon @click="hide">
                            <v-icon>$left_arrow</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="8" class="app-title text-truncate">
                        {{ titleChat }}
                    </v-col>
                    <v-col cols="2" align="right">
                        <input
                            type="file"
                            ref="fileUpload"
                            style="display: none"
                            @change="onFileSelected"
                        />
                        <v-btn :loading="loading" @click="$refs.fileUpload.click()" color="primary" icon>
                            <v-icon class="mr-1">mdi-paperclip</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-app-bar>

            <v-img eager contain class="img-profile" :src="clientImg"/>

            <v-card-text class="chat-wrapper">
                <v-row no-gutters class="fill-height">
                    <v-col cols="12" class="fill-height pt-3">
                        <v-card class="card-subscription kimsa-elevation" :class="isMobile ? 'no-radius' : ''" light>
                            <div class="client-name">
                                <v-icon class="border-icon">mdi-message-processing</v-icon>
                                {{ clientName }}
                            </div>

                            <div ref="chat" class="text-section">

                                <template v-if="loadingMessages">
                                    <v-skeleton-loader type="list-item-avatar-three-line"/>
                                    <v-skeleton-loader type="list-item-avatar-three-line"/>
                                    <v-skeleton-loader type="list-item-avatar-three-line"/>
                                    <v-skeleton-loader type="list-item-avatar-three-line"/>
                                    <v-skeleton-loader type="list-item-avatar-three-line"/>
                                </template>

                                <template v-else>

                                    <div class="text-center caption pa-3" v-if="messages.length === 0">
                                        {{ $t('common.no_chat_messages') }}
                                    </div>

                                    <div v-for="message in messages">
                                        <message-from-me v-if="!receptorMessage(message.from)" :img="accountImg"
                                                         :message="message"/>
                                        <message-from-others v-else :img="clientImg" :message="message"/>
                                    </div>

                                    <v-row v-show="read">
                                        <v-col cols="10" sm="11" align="right" class="caption pa-0">
                                            {{ $t('common.read') }}
                                            <v-icon small>mdi-check-all</v-icon>
                                        </v-col>
                                    </v-row>
                                </template>

                            </div>

                            <div class="bottom-inputs">
                                <v-text-field
                                    :placeholder="$t('common.send_placeholder')"
                                    dense outlined hide-details
                                    style="border-radius: 8px"
                                    v-model="message" @keydown.enter="send"
                                    append-icon="mdi-send"
                                    color="#99CC00"
                                    :loading="sending"
                                    @click:append="send"
                                    ref="input"
                                />
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>

        </v-card>
    </v-dialog>
</template>

<script>

import {db, Timestamp, storage, storageRef} from '@/utils/Firebase'
import {mapState, mapMutations} from 'vuex'
import MessageFromMe from "@/components/common/chat/MessageFromMe";
import MessageFromOthers from "@/components/common/chat/MessageFromOthers";

export default {
    components: {MessageFromOthers, MessageFromMe},
    props: {
        clientId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            dialog: false,
            message: '',
            messages: [],
            client: null,
            chatId: null,
            selectedFile: null,
            loading: false,
            loadingMessages: true,
            windowHeight: window.innerHeight,
            firstMessage: false,
            sending: false
        }
    },
    computed: {
        ...mapState(['dialogActive']),
        clientName(vm = this) {
            return vm.client?.name || ''
        },
        read(vm = this) {
            if (!vm.dialog || !vm.chatId || vm.messages.length <= 0) return false
            let lastMessage = vm.messages[vm.messages.length - 1]
            if (lastMessage.from !== vm.currentUser.uid) {
                db.collection('privateChats').doc(vm.chatId).collection('messages').doc(lastMessage.id).update({read: true})
                db.collection('privateChats').doc(vm.chatId).update({['lastMessage.read']: true})
                return false
            } else return lastMessage.read
        },
        clientImg(vm = this) {
            return vm.client?.avatar || vm.imgPlaceholder
        },
        accountImg(vm = this) {
            return vm.account?.avatar || vm.imgPlaceholder
        },
        titleChat(vm = this) {
            if (vm.$route.name === 'student.chats' || vm.$route.name === 'coach.students.chats') return vm.$t('common.chat')
            if (vm.account?.accountType === 'coach') return vm.$t('student.chat')
            if (vm.account?.accountType === 'student') return vm.$t('coach.chat')
            return ''
        }
    },
    mounted() {
        const vm = this
        const resetView = () => {
            vm.windowHeight = window.innerHeight
            vm.scrollToEnd()
        }
        window.addEventListener('resize', resetView)
        vm.reloadChat()
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        async show() {
            const vm = this
            vm.dialog = true
            vm.setDialogActive(true)
            await vm.reloadChat()
            setTimeout(() => {
                vm.scrollToEnd()
            }, 500);
        },
        hide() {
            const vm = this
            vm.$emit('hideChat')
            vm.chatId = null
            vm.messages = []
            vm.dialog = false
            vm.setDialogActive(false)
        },
        async reloadChat() {
            const vm = this
            if (!!vm.clientId && !vm.chatId) await vm.chargeChatId()
        },
        async send() {
            const vm = this
            if (!vm.message) return;
            vm.sending = true

            let payload = {
                message: vm.message,
                from: vm.currentUser.uid,
                // from: vm.coachId,
                read: false,
                timestamp: Timestamp.now(),
                type: 'text'
            }

            vm.message = ''
            if (vm.firstMessage) {
                await vm.createChatId()
                vm.firstMessage = false
            }

            await db.collection('privateChats').doc(vm.chatId).collection('messages').add(payload)
            await db.collection('privateChats').doc(vm.chatId).update({lastMessage: payload})
            vm.scrollToEnd()

            if (vm.$refs.input) vm.$refs.input.focus()
            vm.sending = false
        },
        scrollToEnd() {
            const vm = this
            vm.$nextTick(() => {
                if (!!vm.$refs.chat && vm.$refs.chat.scrollHeight !== undefined) {
                    vm.$refs.chat.scrollTop = vm.$refs.chat.scrollHeight
                }
            })
        },
        receptorMessage(id) {
            const vm = this
            return id === vm.clientId;
        },
        async getMessages() {
            const vm = this
            // console.log('vm.chatId',vm.chatId)
            try {
                await vm.$bind('messages', db.collection('privateChats').doc(vm.chatId).collection('messages').orderBy('timestamp'))
            } catch (err) {
                console.log('Error trying to map chats', err.message)
            } finally {
                vm.loadingMessages = false
            }
        },
        onFileSelected() {
            const vm = this
            vm.selectedFile = vm.$refs.fileUpload.files[0]
            vm.uploadTask()
        },
        async uploadTask() {
            const vm = this
            vm.loading = true
            let uniqueName = `${Date.now()}-${vm.selectedFile.name}`
            let savePath = `/${vm.currentUser.uid}/chats/${vm.clientId}/${uniqueName}`
            let uploadTask = await storageRef.child(savePath).put(vm.selectedFile)
            let downloadURL = await uploadTask.ref.getDownloadURL()

            let payload = {
                message: vm.selectedFile.name,
                from: vm.currentUser.uid,
                read: false,
                timestamp: Timestamp.now(),
                type: 'attachment',
                file: {savepath: savePath, downloadURL: downloadURL}
            }

            await db.collection('privateChats').doc(vm.chatId).collection('messages').add(payload)
            await db.collection('privateChats').doc(vm.chatId).update({lastMessage: payload})

            vm.loading = false
            vm.scrollToEnd()
        },
        async chargeChatId() {
            const vm = this
            vm.loadingMessages = true
            // console.log('vm.clientId',vm.clientId)
            let clientRef = await db.collection('users').doc(vm.clientId).get()
            vm.client = clientRef.data()

            let coachId = clientRef.id
            let studentId = vm.currentUser.uid

            if (vm.accountType === 'coach') {
                coachId = vm.currentUser.uid
                studentId = clientRef.id
            }

            let chatRef = db.collection('privateChats')
            chatRef.where('type', '==', 'coach_student')
            chatRef.where('participants', 'in', [[coachId, studentId]])
                .get().then(chat => {
                if (chat.docs.length > 0) {
                    vm.chatId = chat.docs[0].id
                    vm.getMessages()
                } else {
                    vm.firstMessage = true
                    vm.loadingMessages = false
                }
            })
        },
        async createChatId() {
            const vm = this
            let clientRef = await db.collection('users').doc(vm.clientId).get()
            vm.client = clientRef.data()

            let coachId = clientRef.id
            let studentId = vm.currentUser.uid

            if (vm.account.accountType === 'coach') {
                coachId = vm.currentUser.uid
                studentId = clientRef.id
            }

            await db.collection('privateChats').add({
                type: 'coach_student',
                participants: [coachId, studentId]
            }).then(chat => {
                vm.chatId = chat.id
                vm.getMessages()
            })
        }
    },
    watch: {
        dialogActive(val) {
            if (!val && this.dialog) this.hide()
        },
        read(val) {
            if (val) this.scrollToEnd()
        },
        loadingMessages(val) {
            if (!val) this.scrollToEnd()
        },
        messages() {
            this.scrollToEnd()
        },
        clientId(val) {
            if (!!val && !this.chatId) this.chargeChatId()
        }
    },
}

</script>

<style scoped>

.app-title {
    font-size: 20px;
    text-align: center;
}

.img-profile {
    background-color: rgba(0, 0, 0, .1);
    height: 150px;
}

.chat-wrapper {
    padding: 0 !important;
    height: 100%;
    background-color: rgba(0, 0, 0, .1);
}

.card-subscription {
    top: -12px;
    border-radius: 8px;
    height: calc(100% + 12px);
}

.border-icon {
    color: #ffffff;
    text-shadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
}

.client-name {
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    padding: 12px 4px;
    font-weight: bold;
    color: #333333;
    border-bottom: 1px solid #333333;
}

.text-section {
    height: calc(100% - 55px - 50px);
    padding: 20px;
    overflow-y: scroll;
    overflow-x: hidden;
}

.text-section::-webkit-scrollbar {
    width: 2px;
    height: 2px;
}

.text-section::-webkit-scrollbar-button {
    width: 0;
    height: 0;
}

.text-section::-webkit-scrollbar-thumb {
    background: #333333;
    border: 0 none #ffffff;
    border-radius: 50px;
}

.text-section::-webkit-scrollbar-thumb:hover {
    background: #ffffff;
}

.text-section::-webkit-scrollbar-thumb:active {
    background: #000000;
}

.text-section::-webkit-scrollbar-track {
    background: #FFFFFF;
    border: 0 none #ffffff;
    border-radius: 50px;
}

.text-section::-webkit-scrollbar-track:hover {
    background: #666666;
}

.text-section::-webkit-scrollbar-track:active {
    background: #333333;
}

.text-section::-webkit-scrollbar-corner {
    background: transparent;
}

.bottom-inputs {
    position: absolute;
    display: flex;
    padding: 8px;
    width: 100%;
    height: 50px;
    align-items: center;
    bottom: 4px;
    border-top: 1px solid #333333;
}

.card-container {
    border-radius: 8px !important;
}

</style>
